import React, { useMemo } from "react";
import { useGlobalTimer } from "../../../providers/GlobalTimerProvider";
import TimeRenderListView from "./TimeRenderListView";
import CustomHtmlTooltip from "../../../helpers/CustomHtmlTooltip";
import { findTimeDifferenceForEtd , formatDateTime } from "../../../helpers/Util";
import "./AdvEtrTimeDisplayListView.scss";

interface EtdTimeDisplayListViewProps {
    eventTime: string;
}

export default function EtdTimeDisplayListView({ eventTime }: EtdTimeDisplayListViewProps) {
    const currentTime = useGlobalTimer();

    //find if time is in future
    const { diffInDays } = useMemo(() => {
        if (!eventTime) {
            return { diffInDays: 0 };
        }
        return findTimeDifferenceForEtd(currentTime, eventTime);
    }, [currentTime, eventTime]);
    //format time with date and time
    const { time, date } = useMemo(() => {
        if (!eventTime) {
            return { time: "-", date: "-" };
        }
        return formatDateTime(eventTime);
    }, [eventTime]);

    return (
        <span>
            {diffInDays && diffInDays > 0 ? (
                <CustomHtmlTooltip title={`${time} ${date}`} placement="bottom">
                    <span className="adv-etr-display-list-view-cursor">
                        <TimeRenderListView timeDiffStatus="etd" time={time} diffInDays={diffInDays} />
                    </span>
                </CustomHtmlTooltip>
            ) : (
                <TimeRenderListView timeDiffStatus="etd" time={time} />
            )}
        </span>
    );
}